import React, { Suspense, useEffect, useState } from "react";
import { renderRoutes } from "react-router-config";
import Sidebar from "./Components/Sidebar";
import { useLocation } from "react-router";
import { useTranslation } from 'react-i18next';
import LoaderPost from "../../Components/Loader";
import * as constants from "../../Utils/constants";
import InvestmentSidebar from "./Components/Sidebar/InvestmentSidebar";
import { Link } from "react-router-dom";
import { filterCountryIcon, getBatteryLevel, getDeviceInfo, getDeviceName, getLocation, initFirebase, isHomeWidget, isPermission, showLoader, showLoaderGuest, showLoaderPre, showModal } from "../../Utils";
import Bottom from "./Components/Sidebar/Bottom";
import * as pkg from '../../../package.json'
import { BASE_URL } from "../../Utils/url";
import Investment from "./Components/Sidebar/icons/Investment";
import InfoCircle from "./Components/Sidebar/icons/InfoCircle";
import SuperpowerBulb from "./Components/Sidebar/icons/SuperpowerBulb";
import SeniorSidebar from "./Components/Sidebar/SeniorSidebar";
import Menubar from "./Components/Sidebar/icons/Menubar";
import FamilyPeople from "./Components/Sidebar/icons/settings/FamilyPeople";
import {Timeline as TimelineIcon} from "./Components/Sidebar/icons/Timeline";
import Wallet from "./Components/Sidebar/icons/Wallet";
import { Shopping as ShoppingIcon } from "./Components/Sidebar/icons/Shopping";
import Settings from "./Components/Sidebar/icons/Settings";
import Help from "./Components/Sidebar/icons/settings/Help";
import { Chores as ChoreIcon } from "./Components/Sidebar/icons/Chores";
import EducationIcon from "./Components/Sidebar/icons/EducationIcon";
import NotificationsSenior from "./Components/Sidebar/icons/settings/NotificationsSenior";
import SignalR from "../../Components/SignalR";
import { isQ2ServiceProvider } from "../../Utils/ServiceProviders/q2";
import { isLuminServiceProvider } from "../../Utils/ServiceProviders/lumin";
const Loader = () => (
  <></>
)

let bannoTenantCard = false;

const AuthenticatedLayout = (props) => {

  const { t } = useTranslation();
  const [investmentAccountData, setInvestmentAccountData] = useState();
  const { route } = props;
  const location = useLocation();
  const [user, setuser] = useState();
  const [headerTitle, setheaderTitle] = useState("")
  const [isNotification, setisNotification] = useState(true)
  const [isHeaderIcons, setisHeaderIcons] = useState(true)
  const [isSidebar, setisSidebar] = useState(true)
  const [isMobileNav, setisMobileNav] = useState(false)
  const [helpIcon, sethelpIcon] = useState(true);
  const [signalNotificationBell, setSignalNotificationBell] = useState(false);
  const [languageIcon, setlanguageIcon] = useState(true);
  const [superpowerIcon, setSuperpowerIcon] = useState(false);
  const [investmentSidebar, setinvestmentSidebar] = useState(false)
  const [seniorSidebar, setseniorSidebar] = useState(false)
  const [notificationModal, setnotificationModal] = useState(null);
  const [pageClass, setpageClass] = useState(``)
  const [showHeader, setshowHeader] = useState(window.sessionStorage.getItem("__bank"));
  const [mcount, setmcount] = useState(0)
  const [investmentBodyColor, setinvestmentBodyColor] = useState('')

  const [loc, setloc] = useState();
  const [battery, setbattery] = useState();
  const [device, setdevice] = useState();
  const [fcmtoken, setfcmtoken] = useState();
  const [milestoneCompleted, setMilestoneCompleted] = useState(false);
  const [featureTogglesResponse, setFeatureTogglesResponse] = useState([]);
  const [isInvestmentOnly, setIsInvestmentOnly] = useState(false);
  const [investOnlyToggleIcon, setInvestOnlyToggleIcon] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [showTenantMenuToggler, setShowTenantMenuToggler] = useState(true);

  useEffect(() => {

    if (!props.state.user && userLoading === false) {
      setUserLoading(true);
      if (!isHomeWidget()) {
        setTimeout(() => {
          props._user(constants.V6USERS, "", (res) => {
            setuser(res);
          })
        }, 1000);
      } else {
        setuser({ family: {}, self: {} });
      }

    } else {
      if (isHomeWidget()) {
        setuser({ family: {}, self: {} });
      } else {
        setuser(props.state.user);
      }

    }
  }, [props && props.state])

  useEffect(() => {
    const loggedAs = sessionStorage.getItem('loginType');
    if(loggedAs == 'parent' && window.location.pathname.includes('child/')){
      window.location.href = '/parent/dashboard';
      setshowHeader(props.state.theme.values.showHeader)
    }else if(loggedAs == 'child' && window.location.pathname.includes('parent/')){
      window.location.href = '/child/dashboard';
    }
  }, [props.state || window.location.href])

  useEffect(() => {
    if (!isPermission(props, `Whitelabel`) === true) {
      props._post(`v7/fundingsource/createFundingSourceByLink`, {
        mode: "aggregation"
      }, res => {
        sessionStorage.setItem('aggregator', res.aggregator);
      })
    }
  }, [])

  useEffect(() => {
    let OSName = "Unknown OS";
    if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
    if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
    if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
    if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
    if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
    document.querySelector('body').classList.add(OSName);
  }, [document])

  useEffect(() => {
    if (featureTogglesResponse && featureTogglesResponse.length && !window.location.pathname.includes('parent/investments') && !window.location.pathname.includes('parent/setting/dashboard')) {
      const isInvestmentsOnly = !featureTogglesResponse.find(e => e === 'InvestmentsOnly');
      setIsInvestmentOnly(isInvestmentsOnly ? true : false)
      if (isInvestmentsOnly) {
        getInvestmentAccount();
        sessionStorage.setItem('puserId', user?.self?.userId);
      } else {
        generateInvestmentBodyColor();
      }
    }
  }, [featureTogglesResponse])

  useEffect(() => {
    if (props.state && props.state.theme.values) {
      //window.document.title = props.state.theme.values.tenantFullName;
      setshowHeader(props.state.theme.values.showHeader)
      // setprimaryColor(props.state.theme.values.primaryColor)
    }
  }, [props.state])

  useEffect(() => {
    if (showHeader === true) {
      initFirebase(setfcmtoken);
      getLocation(setloc);
      getBatteryLevel(setbattery);
      //getDeviceName();
      getDeviceInfo(setdevice);
    }
  }, [showHeader])

  useEffect(() => {
    if (props.state.theme.values.primaryColor) {
      milestones()
    }
  }, [props && props.state && props.state.theme])

  useEffect(() => {
    if (investmentBodyColor) {
      getInvestmentAccount();
    }
  }, [investmentBodyColor])

  useEffect(() => {

    if (superpowerIcon) {
      milestones_count();
    }

  }, [superpowerIcon])

  useEffect(() => {

    if (location.pathname) {

      if (window.tecton && window.tecton.actions) {
        console.warn(`tecton found`)
        window.tecton.actions.keepAlive();
        document.addEventListener('click', window.tecton.actions.keepAlive, false);
        document.addEventListener('scroll', window.tecton.actions.keepAlive, false);
        document.addEventListener('mousemove', window.tecton.actions.keepAlive, false);
        document.addEventListener('keypress', window.tecton.actions.keepAlive, false);
      }


      logoutAfter();
      let filterRoutes = route.routes.filter(e => e.path === location.pathname);

      if (filterRoutes.length === 0) {
        filterRoutes = route.routes.filter(e => (e.path) ? location.pathname.indexOf(e.path.split(":")[0]) !== -1 : false);
      }

      if (location.pathname === "/parent/children/card") {
        bannoTenantCard = true;
      }

      if (filterRoutes.length > 0 && filterRoutes[0].params) {
        getFeatureFlag();
        setheaderTitle(filterRoutes[0].params.title);
        setisMobileNav(filterRoutes[0].isMobileNav);
        setisNotification(filterRoutes[0].params.notificationBell);
        setlanguageIcon(filterRoutes[0].params.languageIcon);
        setSuperpowerIcon(filterRoutes[0].params.superpowerIcon);
        setInvestOnlyToggleIcon(filterRoutes[0].params.allowInvestOnlyToggle)
        sethelpIcon(filterRoutes[0].params.helpIcon);
        setSignalNotificationBell(filterRoutes[0].params.signalNotificationBell);
        setisHeaderIcons((filterRoutes[0].params.headerIcons === false) ? filterRoutes[0].params.headerIcons : true);
        setisSidebar((filterRoutes[0].params.sidebar === false) ? filterRoutes[0].params.sidebar : true);
        setinvestmentSidebar((filterRoutes[0].params.investmentSidebar === true) ? filterRoutes[0].params.investmentSidebar : false);
        setseniorSidebar((filterRoutes[0].params.seniorSidebar === true) ? filterRoutes[0].params.seniorSidebar : false);
        setpageClass('page' + filterRoutes[filterRoutes.length - 1].path.replace(/:/g, '').replace(/\//g, '-'));
        setShowTenantMenuToggler(filterRoutes[0].params.showMenuToggler)
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`page-register`));
        //getInvestmentAccount();

      } else {
        setheaderTitle(``);
      }
    }

  }, [location.pathname])

  useEffect(() => {
    if (notificationModal === true) {
      showModal("notificationModal");
      // setnotificationModal(false);
    }
    if (notificationModal === false) {
      setnotificationModal(true);
    }
  }, [notificationModal])

  useEffect(() => {
    if (loc && device && battery && fcmtoken) {
      const deviceToken = {
        ...loc, ...device, ...battery, ...fcmtoken,
        provider: "FCM", app_version: "2.1.3",
        app_build_number: "2.1.3",
        is_simulator: false,
        ipAddress: "127.0.0.1"
      };
      //console.log(deviceToken);
    }
  }, [loc, device, battery, fcmtoken])

  const generateInvestmentBodyColor = () => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(props.state.theme.values.primaryColor);
    if (!result) { return }
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);
    const color = `rgba(${r}, ${g}, ${b}, 0.125)`;
    setinvestmentBodyColor(color)
  }

  const milestones = () => {

    if (bannoTenantCard) {
      return;
    }

    if (isHomeWidget()) { return }

    props._list(constants.MILESTONES, null, (res) => {
      let activated = [true, false, false, false, false, false, false, false, false, false, false, false, false];
      activated[1] = res.find(e => e.milestoneId === 2).isCompleted;
      activated[2] = res.find(e => e.milestoneId === 3).isCompleted;
      activated[3] = res.find(e => e.milestoneId === 1).isCompleted;
      activated[4] = res.find(e => e.milestoneId === 5).isCompleted;
      activated[5] = res.find(e => e.milestoneId === 6).isCompleted;
      activated[6] = (res.find(e => e.milestoneId === 4 && e.isCompleted === true) ? res.find(e => e.milestoneId === 4 && e.isCompleted === true).isCompleted : false);
      activated[7] = res.find(e => e.milestoneId === 7).isCompleted;
      activated[8] = res.find(e => e.milestoneId === 9).isCompleted;
      activated[9] = res.find(e => e.milestoneId === 10).isCompleted;
      activated[10] = res.find(e => e.milestoneId === 11).isCompleted;
      activated[11] = res.find(e => e.milestoneId === 12).isCompleted;
      activated[12] = res.find(e => e.milestoneId === 8).isCompleted;
      setMilestoneCompleted(activated.every((e) => e === true))
    })
  }

  const milestones_count = () => {
    props._list(constants.MILESTONES_COUNT, null, res => {
      setmcount(res.remainingCount);
    }, err => { }, false);
  }

  const toggleSidebar = () => {
    document.querySelector('.parent-left-sidebar').classList.toggle('active');
  }

  const getFeatureFlag = () => {
    if (bannoTenantCard) {
      return;
    }

    if (props.state && props.state.crud.featuretoggle) { return }

    if (isHomeWidget()) { return }

    // props._list(constants.FEATURE_FLAG_V4, null, res => {
    //   setFeatureTogglesResponse(res);
    // }, err => { }, false)

    props._feature(constants.FEATURE_FLAG_V4, null, res => {
      setFeatureTogglesResponse(res);
    }, err => { }, false)
  }

  const logoutAfter = () => {
    var idleInterval;

    if (!BASE_URL.AUTO_LOGOUT) {
      console.warn('Auto Logout is disabled')
      clearInterval(idleInterval);
      return;
    }

    if (idleInterval) {
      clearInterval(idleInterval);
    }

    document.removeEventListener(`mousemove`, () => { });
    document.removeEventListener(`keypress`, () => { });

    var idleTime = 0;

    document.addEventListener(`mousemove`, () => {
      idleTime = 0;
    })

    document.addEventListener(`keypress`, () => {
      idleTime = 0;
    })

    const timerIncrement = () => {
      idleTime = idleTime + 1;
    }

    idleInterval = setInterval(timerIncrement, 60000);

  }

  const getInvestmentAccount = () => {
    const isInvestmentsOnly = !featureTogglesResponse.find(e => e === 'InvestmentsOnly') || JSON.parse(sessionStorage.getItem('isInvestOnly')) === true;
    
    // console.log(`investmentBodyColor`,investmentBodyColor);
    if (!isInvestmentsOnly) {
      return;
    }
    let apiUrl;
    let plocData = sessionStorage.getItem('puserId');
    let clocData = sessionStorage.getItem('userId');
    if (plocData != null || plocData != undefined) {
      apiUrl = constants.INVESTMENTS_CREATE
    }
    else {
      apiUrl = constants.INVESTMENTS_CREATE + `?wardId=${clocData}`
    }

    if (isHomeWidget()) { return }

    props._investment_account(apiUrl, null, (res) => {
      const currentUser = sessionStorage.getItem('puserId') || sessionStorage.getItem('userId');
      const d = res.filter((e) => (e.userGuid === currentUser))[0];

      // d.mode = "None";
      sessionStorage.setItem('practiceMode', d.mode);
      setInvestmentAccountData(d);
      // if(d.mode === "None"){
      //   props.history.push(`/parent/investments`);
      // }else{
      //   props.history.push('/parent/investments/dashboard');
      // }
      if (JSON.parse(sessionStorage.getItem('isInvestOnly'))) {
        document.querySelectorAll(`body`).forEach(e => e.classList.add(`investOnly`));
      }
      if (props.location.pathname.includes('/parent/investments') && d.mode === 'Practice') {
        document.querySelectorAll(`body`).forEach(e => e.classList.add(`parent-module`));
        document.querySelectorAll(`body`).forEach(e => e.classList.add(`practice-mode`));
        document.querySelectorAll(`body`).forEach(e => e.style.backgroundColor = investmentBodyColor);
        // document.querySelectorAll('.tenant-menubar.investment').forEach(e => e.style.backgroundColor = '#e6e9e9');

      }
      else {
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`parent-module`));
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`practice-mode`));
        document.querySelectorAll(`body`).forEach(e => e.style.backgroundColor = '#ffffff');
        // document.querySelectorAll('.tenant-menubar').forEach(e => e.style.backgroundColor = '#ffffff');
      }
      if (props.location.pathname.includes('/parent/investments/child/settings')) {
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`parent-module`));
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`practice-mode`));
        document.querySelectorAll(`body`).forEach(e => e.style.backgroundColor = '#ffffff');
        // document.querySelectorAll('.tenant-menubar').forEach(e => e.style.backgroundColor = '#ffffff');
      }

    }, err => {
    })
  }

  const onInvestmentOnlyActivation = () => {
    props._user(constants.V6USERS, "", (res) => {
      const userData = res;
      props._list(constants.FEATURE_FLAG_V4, null, res => {
        getInvestmentAccountDataRaw(userData)
      }, err => { }, false)
    })
    sessionStorage.setItem('isInvestOnly', true)
  }

  const getInvestmentAccountDataRaw = (userData) => {
    props._list(constants.INVESTMENTS_CREATE, null, (res) => {
      const d = res.filter((e) => (e.userGuid === userData.self.userId))[0];
      if (d.mode === "None") {
        props.history.push(`/parent/investments`);
      } else {
        props.history.push('/parent/investments/dashboard');
      }
    }, err => {

    })
  }

  const onlanguagechange = (lang) => {
    window.sessionStorage.setItem(constants.LOCALSTORAGE.lang, lang);
    setTimeout(() => {
      window.location.reload();
    }, 100)
  }

  const logout = () => {
    constants.SESSSION_OUT(props);
  };

  return (
    <>
      {user &&
        <>
          {showHeader ?
            <header className="header-chorecheck">
              <div className="navbar-container">
                <div className="logo">
                  <img src={props.state.theme.values.logo} className="pointer" alt="rego logo" onClick={() => window.location.reload()} />
                </div>
              </div>
            </header>
            : null}
          <div className="main-container">
            <div className={`dashboard-wrapper ${isSidebar ? 'sidebar' : 'nosidebar'}`}>
              <div className="toggleSidebar" onClick={toggleSidebar}><img src={`${BASE_URL.CDN}/tenants/${props.state.theme.values.tenantFullName}/web/public/assets/images/menuBar.svg`} alt="menubar" /></div>

              {isSidebar ?
                <>
                  {props.state.theme.values.navLocation ? (
                    showHeader && (props.state.theme.values.navLocation === 'iFrame-Left' || props.state.theme.values.navLocation === 'Page-Top' || props.state.theme.values.navLocation === 'Page-Left') &&
                    <Sidebar {...props} showHeader={showHeader} />
                  ) :
                    <Sidebar {...props} showHeader={showHeader} />
                  }

                  {isLuminServiceProvider(props) && <Sidebar {...props} showHeader={showHeader} />}

                  <div className={`dashboard-right-article ${pageClass} ${showHeader ? 'with-Header' : 'no-sidebar'} ${sessionStorage.getItem('lang') || 'en'}`}>
                    <LoaderPost identifier={'0'} />

                    {isHeaderIcons === false ?
                      null
                      :
                      <>

                        {/* <h1 className={`dashboard-heading ${isNotification && helpIcon && languageIcon?'':'none'}`}>{t(headerTitle)} */}
                        <h1 className='dashboard-heading'>

                          {/* THIS MENU WILL DISPLAY ONLY for Q2 & CSI */}
                          {!showHeader && (
                            (props.state.theme.values.navLocation === 'Hamburger' && showTenantMenuToggler) ||
                            (props.state.theme.values.tenantFullName === 'camden' || props.state.theme.values.tenantFullName === 'csi' || props.state.theme.values.tenantFullName === 'service1')
                          ) &&
                            <div className="tenant-toggle-menu dropdown">
                              <div className="menu-toggler dropdown-toggle" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div className="hamburger-wrapper">
                                  <Menubar color={props.state.theme.values.tertiaryGrayColor} />
                                </div>
                                <div className="text">{t('menu')}</div>
                              </div>

                              <div className="menu-toggle-items dropdown-menu" aria-labelledby="dropdownMenu2">
                                {location.pathname != "/parent/dashboard" &&
                                  <li><Link to="/parent/dashboard"><div className="icon"><FamilyPeople {...props} color={props.state.theme.values.primaryColor} /></div>{t('my_family')}</Link></li>
                                }
                                <li><Link to="/parent/chores"><div className="icon"><ChoreIcon {...props} color={props.state.theme.values.primaryColor} /></div>{t('chores')}</Link></li>
                                {isPermission(props, `Shopping`) === true &&
                                  <li><Link to="/parent/shopping"><div className="icon"><ShoppingIcon {...props} color={props.state.theme.values.primaryColor} /></div>{t('shopping')}</Link></li>
                                }
                                <li><Link to="/parent/education"><div className="icon"><EducationIcon {...props} color={props.state.theme.values.primaryColor} /></div>{t('education')}</Link></li>
                                {!isPermission(props, `Whitelabel`) === true &&
                                  <li><Link to="/parent/wallet"><div className="icon"><Wallet {...props} color={props.state.theme.values.primaryColor} /></div>{t('wallet')}</Link></li>
                                }
                                {isPermission(props, `Whitelabel`) === true &&
                                  <li><Link to="/parent/transfer"><div className="icon"><Wallet {...props} color={props.state.theme.values.primaryColor} /></div>{t('transfer')}</Link></li>
                                }
                                <li><Link to="/parent/timeline"><div className="icon"><TimelineIcon {...props} color={props.state.theme.values.primaryColor} /></div>{t('timeline')}</Link></li>
                                {isPermission(props, `Whitelabel`) === true &&
                                  <li><Link to="/parent/superpower-explore"><div className="icon"><SuperpowerBulb {...props} color={props.state.theme.values.primaryColor} /></div>{t('explore')}</Link></li>
                                }
                                <li><Link to="/parent/setting/dashboard"><div className="icon"><Settings {...props} color={props.state.theme.values.primaryColor} /></div>{t('settings')}</Link></li>
                                {props.state.signalr?.signalBankCalloutMsg?.length > 0 &&
                                  <li>
                                    <Link to="/parent/signal/notifications">
                                      <div className="icon"><NotificationsSenior {...props} color={props.state.theme.values.primaryColor} /></div>
                                      {t('notifications')}
                                    </Link>
                                    <span className="count-badge">{props.state.signalr.signalBankCalloutMsg.length}</span>
                                  </li>
                                }
                              </div>
                            </div>
                          }
                          {t(headerTitle)}

                          <div className="heading-right-icon-list ml-auto">
                            {signalNotificationBell && props.state.signalr.signalBankCalloutMsg.length > 0 &&
                              <li className="signalR-notifications" onClick={(e) => props.history.push('/parent/signal/notifications')}>
                                <NotificationsSenior {...props} color={props.state.theme.values.tertiaryGrayColor} />
                                <span className="count-badge">{props.state.signalr.signalBankCalloutMsg.length}</span>
                              </li>
                            }
                            {window.location.host.includes('-app.mazoolaplus.com') && investOnlyToggleIcon &&
                              <li className="investmentToggle" onClick={(e) => onInvestmentOnlyActivation()}>
                                <Investment />
                              </li>
                            }
                            {superpowerIcon && !milestoneCompleted && isPermission(props, `Whitelabel`) === false &&
                              // superpower-icon
                              <li className="superpower-icon" onClick={() => props.history.push('/parent/superpowers')}>
                                {props.state.theme.values.tenantFullName &&
                                  <SuperpowerBulb {...props} color={props.state.theme.values.tertiaryGrayColor} />
                                }
                                {mcount > 0 &&
                                  <span className="dot">{mcount}</span>
                                }
                              </li>
                            }
                            {helpIcon ?
                              <li className="menuHelp" onClick={() => props.history.push('/parent/help')}>
                                {props.state.theme.values.tenantFullName &&
                                  <Help {...props} color={props.state.theme.values.tertiaryGrayColor} />
                                }
                              </li>
                              : null}
                            {isNotification ?
                              <li onClick={() => { setnotificationModal(!notificationModal); }}>
                                <img alt="bell icon" src={`${BASE_URL.CDN}/tenants/${props.state.theme.values.tenantFullName}/web/public/assets/images/bell.svg`} />
                                <span className="notification-unred-"></span>
                              </li>
                              : null}

                            {languageIcon && !isPermission(props, `Whitelabel`) &&
                              <li className="language-changer dropdown">
                                <div className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                  <img src={filterCountryIcon(window.sessionStorage.getItem("lang"))} /> {window.sessionStorage.getItem("lang") ? window.sessionStorage.getItem("lang") : constants.FALLBACK_LANG}
                                </div>
                                <ul className="dropdown-menu">
                                  <li onClick={() => onlanguagechange('en')}><img src="../assets/images/Mazoola/flags/USFlag.svg" width="14px" />English</li>
                                  <li onClick={() => onlanguagechange('es')}><img src="../assets/images/Mazoola/flags/ESFlag.svg" width="14px" />Spanish</li>
                                  <li onClick={() => onlanguagechange('fr')}><img src="../assets/images/Mazoola/flags/FRFlag.svg" width="14px" />French</li>
                                </ul>
                              </li>
                            }
                          </div>
                        </h1>
                      </>
                    }
                    <Suspense
                      fallback={<Loader />}
                    >

                      {renderRoutes(route.routes)}

                    </Suspense >
                  </div>

                </>
                : <>
                  {/* <LoaderPost identifier={'0'} loaderclass={`center-loader`}/> */}
                  {investmentSidebar &&
                    <>
                      {(showHeader && !JSON.parse(sessionStorage.getItem('isInvestOnly'))) &&
                        <InvestmentSidebar {...props} />
                      }
                      <div className={`dashboard-right-article ${pageClass} ${(showHeader && !JSON.parse(sessionStorage.getItem('isInvestOnly'))) ? 'with-Header' : 'no-sidebar'}`}>
                        {(!showHeader || JSON.parse(sessionStorage.getItem('isInvestOnly')) === true) &&
                          <div className={`tenant-menubar ${(!isInvestmentOnly || JSON.parse(sessionStorage.getItem('isInvestOnly')) === true) && 'investment'}`}>
                            <ul>
                              {(featureTogglesResponse.find(e => e === 'InvestmentsOnly') && !JSON.parse(sessionStorage.getItem('isInvestOnly'))) &&
                                <li className={`${location.pathname === "/parent/dashboard" ? 'active' : ''}`}>
                                  <Link to="/parent/dashboard">{t('my_family')}</Link>
                                </li>
                              }
                              <li className={`${location.pathname === "/parent/investments/dashboard" ? 'active' : ''}`}>
                                <Link to="/parent/investments/dashboard">{t('Dashboard')}</Link>
                              </li>
                              <li className={`${location.pathname === "/parent/investments/timeline" ? 'active' : ''}`}>
                                <Link to="/parent/investments/timeline">{t('timeline')}</Link>
                              </li>
                              <li className={`${location.pathname === "/parent/investments/research" ? 'active' : ''}`}>
                                <Link to="/parent/investments/research">{t('research')}</Link>
                              </li>
                              <li className={`${location.pathname === "/parent/investments/watchlist" ? 'active' : ''}`}>
                                <Link to="/parent/investments/watchlist">{t('investment_watchlist.watchlist')}</Link>
                              </li>
                              <li className={`${location.pathname === "/parent/investments/reports" ? 'active' : ''}`}>
                                <Link to="/parent/investments/reports">{t('reports')}</Link>
                              </li>
                              {!featureTogglesResponse.find(e => e === 'InvestmentsOnly') &&
                                <li className={`${location.pathname === "/parent/parentInvestmentSettingList" ? 'active' : ''}`}>
                                  <Link to="/parent/parentInvestmentSettingList">{t('settings')}</Link>
                                </li>
                              }
                            </ul>
                          </div>
                        }
                        <LoaderPost identifier={'0'} />
                        <Suspense
                          fallback={<Loader />}
                        >

                          {renderRoutes(route.routes)}

                        </Suspense >
                      </div>
                    </>
                  }

                  {seniorSidebar &&
                    <>
                      <SeniorSidebar {...props} />
                      <div className={`dashboard-right-article ${pageClass} `}>
                        <LoaderPost identifier={'0'} />
                        <Suspense
                          fallback={<Loader />}
                        >

                          {renderRoutes(route.routes)}

                        </Suspense >
                      </div>
                    </>
                  }

                  {!investmentSidebar && !seniorSidebar &&
                    <div className={`dashboard-right-article ${pageClass}`}>
                      <LoaderPost identifier={'0'} loaderclass={`center-loader`} />
                      <Suspense
                        fallback={<Loader />}
                      >

                        {renderRoutes(route.routes)}

                      </Suspense >
                    </div>
                  }
                </>
              }
            </div>

            <Bottom {...props} sidebar={isSidebar} showHeader={showHeader} isMobileNav={isMobileNav} investmentSidebar={investmentSidebar} seniorSidebar={seniorSidebar} />
          </div>
          <SignalR {...props} />
        </>
      }
    </>
  );
};

export default AuthenticatedLayout;
